<template>
    <modal name="magazine-fitting-edit-modal" class="item-modal dgm-modal"
           :width="'80%'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="lookbook_item_wrap">
            <div class="li_title li_title_magazine">제품 수정</div>
            <div class="pb8">
                <div class="li_sub_title_magazine">포즈:</div>
                <el-radio-group v-model="fittingPose" :disabled="fittingStatus != 4">
                    <el-radio :label="1">포즈 1(정자세)</el-radio>
                    <el-radio :label="2">포즈 2</el-radio>
                </el-radio-group>
            </div>
            <div class="pb8" v-if="showGender">
                <div class="li_sub_title_magazine">성별:</div>
                <el-radio-group v-model="fittingGender" @change="changeFittingGender($event)" :disabled="fittingStatus != 4">
                    <el-radio v-for="fg in fittingGenders" :key="`fg-${fg.value}`" :label="fg.value">{{fg.name}}</el-radio>
                </el-radio-group>
            </div>
            <div>
                <div class="li_sub_title_magazine">구분:</div>
                <el-radio-group v-model="fittingPartCount" @change="changeFittingPartCount($event)" :disabled="fittingStatus != 4">
                    <el-radio :label="1" :disabled="isDisabledCount(1)">1건</el-radio>
                    <el-radio :label="2" :disabled="isDisabledCount(2)">2건</el-radio>
                </el-radio-group>
            </div>
            <div class="table_wrap">
                <div class="el-table el-table--fit">
                    <div class="el-table__header-wrapper">
                        <table class="el-table__header el-table__body wp100">
                            <colgroup>
                                <col name="el-table_8_column_59" width="35%">
                                <col name="el-table_8_column_60" width="35%">
                                <col name="el-table_8_column_61" width="auto">
                                <col name="el-table_8_column_62" width="auto">
                                <col name="el-table_8_column_63" width="auto">
                                <col name="el-table_8_column_64" width="80">
                                <col name="gutter" width="0">
                            </colgroup>
                            <thead class="has-gutter">
                            <th class="el-table_8_column_59 text_center  is-leaf">
                                <div class="cell">분류</div>
                            </th>
                            <th class="el-table_8_column_60 text_center  is-leaf">
                                <div class="cell">상품명</div>
                            </th>
                            <th class="el-table_8_column_61 text_center  is-leaf">
                                <div class="cell">관리코드</div>
                            </th>
                            <th class="el-table_8_column_62 text_center  is-leaf">
                                <div class="cell">가격</div>
                            </th>
                            <th class="el-table_8_column_63 text_center  is-leaf">
                                <div class="cell">진열상태</div>
                            </th>
                            <th class="el-table_8_column_64 text_center  is-leaf">
                                <div class="cell">옵션</div>
                            </th>
                            </thead>
                            <tr class="el-table__row" v-for="(item, index) in items" :key="`fc-${index}`">
                                <td class="el-table_8_column_59 text_center">
                                    <div class="cell">
                                        <el-radio-group v-if="index == 1" v-model="item.type" @change="changeItemType(item, index)"  :disabled="fittingStatus != 4">>
                                            <el-radio :label="'bottom'">바텀</el-radio>
                                            <el-radio :label="'pants'">팬츠</el-radio>
                                        </el-radio-group>
                                        <div v-else>{{_getItemTypeName(item.type)}}</div>
                                    </div>
                                </td>
                                <td class="el-table_8_column_60 text_center">
                                    <div class="cell">
                                        <div class="table_img" v-if="item.itemImage.length > 0"
                                             :style="`background-image: url(${item.itemImage[0].org_url}?${setImageOptions(50, null, 'webp')})`"></div>
                                        {{item.i_idx ? item.i_name : '-'}}
                                    </div>
                                </td>
                                <td class="el-table_8_column_61 text_center">
                                    <div class="cell">
                                        {{item.i_idx ? item.i_model : '-'}}
                                    </div>
                                </td>
                                <td class="el-table_8_column_62 text_center">
                                    <div class="cell">
                                        {{item.i_idx ? item.i_price : '-'}}
                                    </div>
                                </td>
                                <td class="el-table_8_column_63 text_center">
                                    <div class="cell">
                                        {{item.i_idx ? item.i_display === 1 ? '진열함' : '진열안함' : '-'}}
                                    </div>
                                </td>
                                <td class="el-table_8_column_64 text_center">
                                    <div class="cell">
                                        <el-button
                                            v-if="fittingStatus == 4"
                                            size="mini"
                                            :type="!item.i_idx ? 'primary' : 'warning'"
                                            @click="openSelectItem(item, index)">{{ !item.i_idx ? '등록' : '수정' }}
                                        </el-button>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mt20 text-center" v-if="fittingStatus == 4" >
                <el-button type="info" @click="modalClose">취소</el-button>
                <el-button type="primary" @click="selectData">등록</el-button>
            </div>
            <div class="mt20 text-center" v-else>
                <el-button type="info" @click="modalClose">닫기</el-button>
            </div>
        </div>
    </modal>

</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import {cateWomanFilter, cateManFilter} from "@/service/itemService";
import imageOption from "@/mixins/imageOption";
import alertMixins from "@/mixins/alertMixins";

export default {
    name: "MagazineFittingEditModal",
    mixins: [imageOption, alertMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            fittingGenders: [
                {value: 2, name: '공용', itemFilters: {terms: {'i_gender': [0]}}, minPart: 2, defaultPart: ['inner', 'bottom'],},
                {value: 0, name: '남성', itemFilters: {terms: {'i_gender': [0, 1]}}, minPart: 2, defaultPart: ['inner', 'bottom'],},
                {value: 1, name: '여성', itemFilters: {terms: {'i_gender': [0, 2]}}, minPart: 1, defaultPart: ['inner', 'bottom'],},
            ],
            fittingPartCount: 2,
            fittingTypes: [

                /*{value: 3, name: '2 건', requireItem: ['inner', 'bottom']},
                {value: 1, name: '1 건(이너)', requireItem: ['inner']},
                {value: 2, name: '1 건(바텀)', requireItem: ['bottom']},*/
            ],

            fittingData: {},
            items: [],
            fittingGender: 2,
            fittingType: 3,
            fittingItemType: 0,
            fittingPose: 1,
            openSelectItemType: '',
            fittingStatus: 4,

            depth1Category: '',
            isSaveClose: true,
            showGender: true,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
    },
    methods: {
        handlerBeforeOpen(event) {
            console.log(event.params)

            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.fittingData)) {
                this.fittingData = event.params.fittingData;
                this.fittingGender = event.params.fittingData.fittingGender;
                this.fittingPartCount = event.params.fittingData.fittingPartCount;
                this.fittingPose = event.params.fittingData.fittingPose;
                this.fittingStatus = event.params.fittingData.fittingStatus;
                let items = [];
                util.Object.each(this.fittingData.fittingItems, (key, value, obj) => {
                    let item = this._getFittingItemDefault();
                    item.type = key;
                    item.i_display = value.info.i_display;
                    item.i_idx = value.info.i_idx;
                    item.i_name = value.info.i_name;
                    item.i_model = value.info.i_model;
                    item.i_price = value.info.i_price;
                    item.itemImage = value.info.itemImage.slice();
                    items.push(item);
                })
                if(items.length > 0) {
                    this.items = items.sort((a,b)=> (a.type !== 'inner')-(b.type !== 'inner') || a.type-b.type);
                }else{
                    if(!util.isEmpty(event.params) && !util.isEmpty(event.params.defaultGender)) {
                        this.fittingGender = event.params.defaultGender;
                    }
                    this.changeFittingGender(this.fittingGender);
                }

            } else {
                console.log('fitting 데이터 미존재')
                event.stop();
            }
            if(!util.isEmpty(event.params) && !util.isEmpty(event.params.depth1Cate)) {
                this.depth1Category = event.params.depth1Cate;
            }else{
                this.depth1Category = '';
            }
            if(!util.isEmpty(event.params) && !util.isEmpty(event.params.isSaveClose)) {
                this.isSaveClose = event.params.isSaveClose;
            }else{
                this.isSaveClose = true;
            }
            if(!util.isEmpty(event.params) && !util.isEmpty(event.params.showGender)) {
                this.showGender = event.params.showGender;
            }else{
                this.showGender = true;
            }
        },
        handlerOpened() {
            EventBus.$on('setSelectOneModalData', this.setSelectModalData);
        },
        handlerBeforeClose() {
            this.fittingData = {};
            this.items = [];
            this.fittingType = 3;
            this.fittingItemType = 0;
            this.fittingGender = 2;
            this.fittingStatus = 4;
            this.depth1Category = '';
            this.isSaveClose = true;
            EventBus.$off('setSelectOneModalData');
        },
        modalClose() {
            this.$modal.hide('magazine-fitting-edit-modal')
        },
        _checkValidator() {
            let result = true;
            util.Array.each(this.items, (data, index, arr) => {
                if (!data.i_idx) {
                    result = false;
                }
            })
            return result;
        },
        selectData() {
            let validator = this._checkValidator();
            if (!validator) {
                this.errorAlert("제품을 선택해주세요.")
                return false;
            }
            //this.fittingData.fittingType = this.fittingType;
            this.fittingData.fittingGender = this.fittingGender;
            this.fittingData.fittingPartCount = this.fittingPartCount;
            this.fittingData.fittingPose = this.fittingPose;
            this.fittingData.fittingItems = {};
            this.fittingData.fittingStatus = 4;
            util.Array.each(this.items, (value, index, arr) => {
                this.fittingData.fittingItems[value.type] = {i_idx: value.i_idx, info: value};
            })
            EventBus.$emit('runSelectFitting', this.fittingData)
            if(this.isSaveClose) {
                this.modalClose();
            }
        },
        openSelectItem(item, index) {
            let type = item.type;
            let params = {part: type};
            this.$api.$item.getPartCategory(params).then(res => res.Data.Result).then(res => {
                let cate2Arr = [];
                if(!util.isEmpty(res.List)) {
                    cate2Arr = res.List;
                }
                let defaultFilter = {
                    query: {
                        bool: {
                            must: [
                                {match: {"i_is_delete": 0}},
                                {match: {'i_display': 1}},
                            ],
                        }
                    }
                }
                if (cate2Arr.length > 0) {
                    //defaultFilter.query.bool.must.push({terms: {'category.level2': cate2Arr}});
                    defaultFilter.query.bool.must.push({terms: {'category.level3': cate2Arr}});
                }
                let selectedGender = this._getGenderData(this.fittingGender);
                let genderFilter = JSON.parse(JSON.stringify(selectedGender.itemFilters));
                defaultFilter.query.bool.must.push(genderFilter);
                if(this.depth1Category != '') {
                    defaultFilter.query.bool.must.push({match: {'category.level1': this.depth1Category}});
                }
                this.openSelectItemType = item.type;
                this.$modal.show('item-one-select-modal', {defaultFilter: defaultFilter, itemData: this.items});
            })
        },
        _getFittingItemDefault() {
            return {type: null, i_idx: null, itemImage: [], i_name: null, i_price: null, i_model: null, i_display: null};
        },
        _getGenderData(gender) {
            let selectedGender = this.fittingGenders.filter(fg => fg.value == gender)[0];
            if(util.isEmpty(selectedGender)) {
                selectedGender = JSON.parse(JSON.stringify(this.fittingGenders[0]));
            }
            return selectedGender;
        },
        changeFittingGender(gender) {
            let selectedGender = this._getGenderData(gender);
            if(gender != selectedGender.value) {
                this.fittingGender = selectedGender.value;
            }
            this.fittingPartCount = 2;
            this.items = [];
            let parts = selectedGender.defaultPart;
            util.Array.each(parts, (value, index, arr) => {
                let defaultItemValue = this._getFittingItemDefault();
                defaultItemValue.type = value;
                this.items.push(defaultItemValue);
            })
        },
        isDisabledCount(count) {
            let selectedGender = this._getGenderData(this.fittingGender);
            if(this.fittingGender != selectedGender.value) {
                return true;
            }
            let minCount = selectedGender.minPart;
            return count < minCount;
        },
        changeFittingPartCount(count) {
            this.items = [];
            if(count == 1) {
                let defaultItemValue = this._getFittingItemDefault();
                defaultItemValue.type = 'dress'
                this.items.push(defaultItemValue);
            }else {
                let selectedGender = this._getGenderData(this.fittingGender);
                if(this.fittingGender != selectedGender.value) {
                    this.fittingGender = selectedGender.value;
                }
                let parts = selectedGender.defaultPart;
                util.Array.each(parts, (value, index, arr) => {
                    let defaultItemValue = this._getFittingItemDefault();
                    defaultItemValue.type = value;
                    this.items.push(defaultItemValue);
                })
            }
        },
        _getItemTypeName(type) {
            switch (type) {
                case 'inner':
                    return '이너';
                case 'dress':
                    return '드레스';
                case 'bottom':
                    return '바텀';
                case 'pants':
                    return '팬츠';
                default:
                    return '';
            }
        },
        changeItemType(item, index) {
            let defaultItem = this._getFittingItemDefault();
            defaultItem.type = item.type;
            this.items[index] = defaultItem;
            this.$forceUpdate();
        },
        setSelectModalData(item) {
            let index = this.items.findIndex(item => item.type == this.openSelectItemType);
            if (index > -1) {
                this.items[index].itemImage = item.itemImage;
                this.items[index].i_idx = item.i_idx;
                this.items[index].i_name = item.i_name;
                this.items[index].i_model = item.i_model;
                this.items[index].i_price = item.i_price;
                this.items[index].i_display = item.i_display;
                this.$forceUpdate();
            }
        },
        tableIdx(index) {
            return this.items.length - index
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
